import { render } from "./AnalysisResults.vue?vue&type=template&id=be4b21f6&scoped=true"
import script from "./AnalysisResults.vue?vue&type=script&lang=js"
export * from "./AnalysisResults.vue?vue&type=script&lang=js"

import "./AnalysisResults.vue?vue&type=style&index=0&id=be4b21f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be4b21f6"]])

export default __exports__